// extracted by mini-css-extract-plugin
export default {"image":"n78_0","aspectRatio":"MFj5h","ratioButton":"WM8Dd"};